module.exports = __webpack_public_path__ + "static/media/feg-honors.e273a782.png";